if (!customElements.get('wls-buybox-gsx')) {
    class WLSBuyboxGSX extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                activeClass: 'is-active',
                unavailableClass: 'is-unavailable',
                main: 'js-wls-buybox-main',
                nav: 'js-wls-buybox-nav',
                item: 'js-wls-buybox-main-item',
                stickyCta: 'js-wls-buybox-sticky-cta',
                swatch: 'js-wls-buybox-swatch',
                variantSelected: 'js-wls-buybox-variant-selected',
                buyButton: 'js-wls-buybox-buy',
                buyPrice: 'js-wls-buybox-buy-price',
                stickyBuyButton: 'js-wls-buybox-sticky-buy',
                qtyInput: 'js-wls-buybox-qty-input',
                qtyMinus: 'js-wls-buybox-qty-minus',
                qtyPlus: 'js-wls-buybox-qty-plus',
                warranty: 'js-wls-buybox-warranty',
                reviews: 'js-wls-buybox-reviews',
                reviewsNav: 'js-wls-buybox-reviews-nav',
                reviewsPrev: 'js-wls-buybox-reviews-prev',
                reviewsNext: 'js-wls-buybox-reviews-next',
            };

            this.elements = {
                main: this.querySelector(`.${this.classes.main}`),
                nav: this.querySelector(`.${this.classes.nav}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                stickyCta: this.querySelector(`.${this.classes.stickyCta}`),
                swatches: this.querySelectorAll(`.${this.classes.swatch}`),
                variantSelected: this.querySelector(`.${this.classes.variantSelected}`),
                buyButton: this.querySelector(`.${this.classes.buyButton}`),
                buyPrice: this.querySelector(`.${this.classes.buyPrice}`),
                stickyBuyButton: this.querySelector(`.${this.classes.stickyBuyButton}`),
                variantInput: this.querySelector('.wls-buybox__shoppay-installments input[name="id"]'),
                qtyInput: this.querySelector(`.${this.classes.qtyInput}`),
                qtyMinus: this.querySelector(`.${this.classes.qtyMinus}`),
                qtyPlus: this.querySelector(`.${this.classes.qtyPlus}`),
                warranty: this.querySelector(`.${this.classes.warranty}`),
                reviews: this.querySelector(`.${this.classes.reviews}`),
                reviewsNav: this.querySelector(`.${this.classes.reviewsNav}`),
                reviewsPrev: this.querySelector(`.${this.classes.reviewsPrev}`),
                reviewsNext: this.querySelector(`.${this.classes.reviewsNext}`),
            };

            this.currentVariantId = this.elements.buyButton ? this.elements.buyButton.dataset.variantId : null;

            this.checkVisibility = this.checkVisibility.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('scroll', this.checkVisibility);
            this.checkVisibility();
        }

        disconnectedCallback() {
            this.destroy();
            window.removeEventListener('scroll', this.checkVisibility);
        }

        checkIfEmpty() {
            if (!this.elements.main || !this.elements.items.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            this.initializeFlickity();
            this.initializeReviewsFlickity();
            this.initVariants();
            this.initQuantity();
            this.initWarranty();
        }

        initWarranty() {
            if (!this.elements.warranty) return;
            this.elements.warranty.addEventListener('change', () => this.updateCheckoutLink());
        }

        initVariants() {
            if (!this.elements.swatches.length) return;

            this.elements.swatches.forEach((swatch) => {
                swatch.addEventListener('click', () => this.selectSwatch(swatch));
            });
        }

        initQuantity() {
            if (!this.elements.qtyInput) return;

            if (this.elements.qtyMinus) {
                this.elements.qtyMinus.addEventListener('click', () => this.stepQuantity(-1));
            }
            if (this.elements.qtyPlus) {
                this.elements.qtyPlus.addEventListener('click', () => this.stepQuantity(1));
            }
            this.elements.qtyInput.addEventListener('change', () => this.updateCheckoutLink());
        }

        getQuantity() {
            const input = this.elements.qtyInput;
            if (!input) return 1;
            const min = parseInt(input.min, 10) || 1;
            const value = parseInt(input.value, 10) || min;
            return Math.max(min, value);
        }

        stepQuantity(delta) {
            const input = this.elements.qtyInput;
            if (!input) return;
            const min = parseInt(input.min, 10) || 1;
            input.value = Math.max(min, this.getQuantity() + delta);
            this.updateCheckoutLink();
        }

        updateCheckoutLink() {
            if (!this.elements.buyButton) return;
            const variantId = this.currentVariantId || this.elements.buyButton.dataset.variantId;
            if (!variantId) return;

            const discount = this.elements.buyButton.dataset.discount;
            let url = `/cart/${variantId}:${this.getQuantity()}`;

            if (this.elements.warranty && this.elements.warranty.checked && this.elements.warranty.dataset.variantId) {
                url += `,${this.elements.warranty.dataset.variantId}:1`;
            }

            if (discount) url += `?discount=${discount}`;

            this.elements.buyButton.setAttribute('href', url);
            if (this.elements.stickyBuyButton) this.elements.stickyBuyButton.setAttribute('href', url);
            if (this.elements.variantInput) this.elements.variantInput.value = variantId;

            this.updatePrice();
        }

        updatePrice() {
            if (!this.elements.buyPrice || !this.elements.buyButton) return;
            const unitPrice = parseInt(this.elements.buyButton.dataset.unitPrice, 10);
            if (Number.isNaN(unitPrice)) return;

            const total = unitPrice * this.getQuantity();
            const format = this.elements.buyButton.dataset.moneyFormat || '${{amount}}';
            // money_format may contain HTML (e.g. <span class=money>…</span>), so render as HTML
            this.elements.buyPrice.innerHTML = this.formatMoney(total, format);
        }

        formatMoney(cents, format) {
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

            const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
                if (Number.isNaN(number) || number == null) return '0';
                const fixed = (number / 100).toFixed(precision);
                const parts = fixed.split('.');
                const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
                const remainder = parts[1] ? decimal + parts[1] : '';
                return dollars + remainder;
            };

            const match = format.match(placeholderRegex);
            const placeholder = match ? match[1] : 'amount';
            let value;

            switch (placeholder) {
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_with_space_separator':
                    value = formatWithDelimiters(cents, 2, ' ', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ', '');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'", '.');
                    break;
                default:
                    value = formatWithDelimiters(cents, 2);
            }

            return format.replace(placeholderRegex, value);
        }

        selectSwatch(swatch) {
            if (swatch.classList.contains(this.classes.unavailableClass)) return;

            this.elements.swatches.forEach((s) => s.classList.remove(this.classes.activeClass));
            swatch.classList.add(this.classes.activeClass);

            const { value, variantId, mediaIndex } = swatch.dataset;

            if (this.elements.variantSelected && value) {
                this.elements.variantSelected.textContent = value;
            }

            if (variantId) {
                this.currentVariantId = variantId;
                this.updateCheckoutLink();
            }

            const index = parseInt(mediaIndex, 10);
            if (this.flktyMain && !Number.isNaN(index) && index >= 0) {
                this.flktyMain.select(index);
            }
        }

        initializeFlickity() {
            this.flktyMain = new Flickity(this.elements.main, {
                cellSelector: '.js-wls-buybox-main-item',
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                draggable: true,
                imagesLoaded: true,
            });

            if (this.elements.nav) {
                this.flktyNav = new Flickity(this.elements.nav, {
                    cellSelector: '.carousel-cell',
                    asNavFor: this.elements.main,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    cellAlign: 'left',
                    draggable: true,
                });
            }

            this.flktyNav.on('staticClick', (event, pointer, cellElement, cellIndex) => {
                if (typeof cellIndex === 'number') {
                    this.flktyMain.select(cellIndex);
                }
            });

            this.flktyMain.on('change', (index) => {
                this.flktyNav.select(index);
            });
        }

        initializeReviewsFlickity() {
            if (!this.elements.reviews) return;
            if (this.elements.reviews.querySelectorAll('.carousel-cell').length < 1) return;

            this.flktyReviews = new Flickity(this.elements.reviews, {
                cellSelector: '.carousel-cell',
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                draggable: true,
                watchCSS: true,
            });

            // Move Flickity's page dots into the navigation row (between the
            // prev/next chevrons), matching the wls-slider__navigation pattern.
            const moveReviewsDots = () => {
                const dots = this.elements.reviews.querySelector('.flickity-page-dots');
                if (dots && this.elements.reviewsNav && this.elements.reviewsNext) {
                    this.elements.reviewsNav.insertBefore(dots, this.elements.reviewsNext);
                }
            };
            moveReviewsDots();
            // watchCSS re-activates the carousel on resize back to mobile.
            this.flktyReviews.on('activate', moveReviewsDots);

            if (this.elements.reviewsPrev) {
                this.elements.reviewsPrev.onclick = () => this.flktyReviews.previous();
            }
            if (this.elements.reviewsNext) {
                this.elements.reviewsNext.onclick = () => this.flktyReviews.next();
            }
        }

        destroy() {
            if (this.flktyMain) {
                this.flktyMain.destroy();
                this.flktyMain = null;
            }

            if (this.flktyNav) {
                this.flktyNav.destroy();
                this.flktyNav = null;
            }

            if (this.flktyReviews) {
                this.flktyReviews.destroy();
                this.flktyReviews = null;
            }
        }

        checkVisibility() {
            if (!this.elements.stickyCta) return;
            let shouldHide = false;
            const hideOnSectionIds = this.getAttribute('data-hide-on-section-ids');

            if (hideOnSectionIds) {
                const sectionIds = hideOnSectionIds.split(',').map(id => id.trim());

                sectionIds.forEach((sectionId) => {
                    const section = document.getElementById(sectionId);
                    if (section) {
                        const rect = section.getBoundingClientRect();

                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            shouldHide = true;
                        }
                    }
                });
            }

            if (shouldHide) {
                this.elements.stickyCta.classList.remove(this.classes.activeClass);
            } else {
                this.elements.stickyCta.classList.add(this.classes.activeClass);
            }
        }
    }

    customElements.define('wls-buybox-gsx', WLSBuyboxGSX);
}
